import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"
import Button from "semantic-ui-react/dist/es/elements/Button/Button"

const SummaryFooter = ({
  nextStep,
  submitButtonLabel,
  continueUrl,
  onSubmit,
  onCancel,
  disableSubmitButton,
  loading,
  light,
  longNextText,
  children,
  continueUrlIsExternal
}) => {
  const submitButton = (
    <Button
      primary
      loading={loading}
      onClick={onSubmit}
      disabled={disableSubmitButton}
      content={submitButtonLabel}
      data-testid="continue"
      type="button"
    />
  )
  return (
    <Grid.Row
      columns={2}
      style={{ paddingLeft: "1rem" }}
      className={`SummaryFooter__Row${light ? "-light" : "-dark"} no-print`}
    >
      <Grid.Column width={longNextText ? 12 : 8} verticalAlign="middle">
        {onCancel != null ? (
          <Button
            basic
            primary
            onClick={onCancel}
            content="Cancel"
            data-testid="cancel"
            type="button"
          />
        ) : null}
        {nextStep != null ? (
          <p>
            <i>Next: {nextStep}</i>
          </p>
        ) : null}
      </Grid.Column>
      <Grid.Column textAlign="right" width={longNextText ? 4 : 8}>
        {children ? (
          children
        ) : disableSubmitButton ? (
          submitButton
        ) : continueUrl ? (
          continueUrlIsExternal ? (
            <a href={continueUrl}>{submitButton}</a>
          ) : (
            <Link to={continueUrl}>{submitButton}</Link>
          )
        ) : (
          submitButton
        )}
      </Grid.Column>
    </Grid.Row>
  )
}

SummaryFooter.propTypes = {
  nextStep: PropTypes.string,
  submitButtonLabel: PropTypes.string,
  continueUrl: PropTypes.string.isRequired,
  continueUrlIsExternal: PropTypes.bool
}

SummaryFooter.defaultProps = {
  continueUrl: "/",
  submitButtonLabel: "Continue",
  continueUrlIsExternal: false
}
export default SummaryFooter
